var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pc_scroll-tab"},[_c('PC-scroll',{ref:"scroll",staticClass:"scroll",attrs:{"data":_vm.list,"click":true}},[_c('ul',{staticClass:"activity-rule-nav"},[_vm._l((_vm.list),function(item,index){return _c('li',{key:index,class:[
            index == _vm.active || (item.brandId && _vm.activeId && _vm.activeId == item.brandId)
              ? 'active'
              : ''
          ],on:{"click":function($event){return _vm.handleSetActive(item, index, $event)}}},[_vm._v(" Móviles ")])})],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }